var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgConstructionColored = function SvgConstructionColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6161FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M18.394 21c-1.091-3.152-4.121-5.455-7.636-5.455C7.242 15.545 4.09 17.848 3 21M10.636 4.636V1M3.97 8.152h13.333M5.667 9.485c.12 2.667 2.303 4.848 4.97 4.848 2.787 0 4.969-2.181 4.969-4.97V7.183c0-2.788-2.182-4.97-4.97-4.97-2.666 0-4.848 2.182-4.97 4.849z"
  })));
};
export default SvgConstructionColored;